import { createRequestTypes } from '../../../../redux/actions/utils';

export const SEND_MAIL = createRequestTypes('SEND_MAIL');
export const sendMail = (params) => ({ type: SEND_MAIL.REQUEST, params});

export const CLEAR_ERROR_SEND_MAIL = 'CLEAR_ERROR_SEND_MAIL';
export const clearErrorSendMail = () => ({type: CLEAR_ERROR_SEND_MAIL});

export const GET_OTP = createRequestTypes('GET_OTP');
export const getOTP = (params) => ({ type: GET_OTP.REQUEST, params});

export const DOWN_TIMEOUT_OTP = 'DOWN_TIMEOUT_OTP';
export const downTimeoutOTP = () => ({type: DOWN_TIMEOUT_OTP});

export const SEND_OTP = createRequestTypes('SEND_OTP');
export const sendOTP = (params) => ({ type: SEND_OTP.REQUEST, params});

export const CLEAR_ERROR_SEND_OTP = 'CLEAR_ERROR_SEND_OTP';
export const clearErrorSendOTP = () => ({type: CLEAR_ERROR_SEND_OTP});

export const CHANGE_ERROR_SEND_OTP = 'CHANGE_ERROR_SEND_OTP';
export const changeErrorSendOTP = (params) => ({type: CHANGE_ERROR_SEND_OTP, params});

export const GET_NEW_OTP = 'GET_NEW_OTP';
export const getNewOTP = (params) => ({ type: GET_NEW_OTP, params});

export const LOGOUT = 'LOGOUT';
export const logout = () => ({ type: LOGOUT});
